module.exports = __webpack_public_path__ + "img/thin-farm-02.b3e9e952.jpg";